import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React from 'react';
import Text from '@magalu/stereo-ui/atoms/Text';
import Button from '@magalu/stereo-ui/atoms/Button';
import { shape } from 'prop-types';
import { usePublisher } from '@magalu/mixer-publisher';
import { useQuestions } from '@magalu/mixer-graphql';
import { routePush } from '@magalu/mixer-utils';
import useUserData from '../../../hooks/useUserData';
import { DialogContainer as Dialog } from './QuestionConfirm.styles';
var QuestionConfirm = function QuestionConfirm(_ref) {
  var _productData$product, _productData$product$;
  var staticProps = _ref["static"],
    structure = _ref.structure,
    productData = _ref.data;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showConfirm = _React$useState2[0],
    setShowConfirm = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    chars = _React$useState4[0],
    setChars = _React$useState4[1];
  var _usePublisher = usePublisher(),
    subscribe = _usePublisher.subscribe,
    publish = _usePublisher.publish,
    unsubscribe = _usePublisher.unsubscribe;
  var position = staticProps.modal.position;
  var _useQuestions = useQuestions(),
    createQuestion = _useQuestions.createQuestion;
  var sellerId = productData == null ? void 0 : (_productData$product = productData.product) == null ? void 0 : (_productData$product$ = _productData$product.seller) == null ? void 0 : _productData$product$.id;
  var handleConfirm = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
      var _structure$route, _structure$route2;
      var user, _yield$createQuestion, data, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return useUserData({
              structure: structure
            });
          case 2:
            user = _context.sent;
            publish('question-confirm:click', {
              userId: user.id
            });
            publish('question-confirm:clean');
            _context.next = 7;
            return createQuestion({
              questionRequest: {
                question: chars,
                sellerId: sellerId || '',
                user: {
                  customerId: user.id,
                  email: user.email,
                  name: user.name
                },
                variationId: (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId) || (structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.questionVariationId)
              }
            }, {
              timeout: 8000
            });
          case 7:
            _yield$createQuestion = _context.sent;
            data = _yield$createQuestion.data;
            error = _yield$createQuestion.error;
            setShowConfirm(false);
            publish('question:submit:response', {
              data: data,
              error: error
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleEdit = function handleEdit(e) {
    publish('question:edit', e);
    setShowConfirm(false);
  };
  var handleCloseFeedback = function handleCloseFeedback() {
    setShowConfirm(false);
  };
  var handleWriteChars = function handleWriteChars(e) {
    setChars(e.target.value.replace('/\n/', ' '));
  };
  var handleRedirectLogin = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
      var _ref4,
        logged,
        userLogged,
        _structure$config,
        config,
        nextParam,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, logged = _ref4.logged;
            _context2.t0 = logged;
            if (_context2.t0) {
              _context2.next = 6;
              break;
            }
            _context2.next = 5;
            return useUserData({
              structure: structure
            });
          case 5:
            _context2.t0 = _context2.sent.isLogged;
          case 6:
            userLogged = _context2.t0;
            if (!userLogged) {
              _structure$config = structure.config, config = _structure$config === void 0 ? {} : _structure$config;
              nextParam = "&next=".concat(window.location.href);
              routePush({
                path: "".concat(config.baseLoginUrl).concat(nextParam),
                spa: false
              });
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleRedirectLogin() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleShowConfirm = function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(data) {
      var _ref6, logged;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _ref6 = data || {}, logged = _ref6.logged;
            if (!logged) {
              _context3.next = 5;
              break;
            }
            setShowConfirm(true);
            _context3.next = 7;
            break;
          case 5:
            _context3.next = 7;
            return handleRedirectLogin(data);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleShowConfirm(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    subscribe('question:form:submit', handleShowConfirm);
    subscribe('question:open:float:modal', handleRedirectLogin);
    subscribe('question:write', handleWriteChars);
    subscribe('question:feedback:close', handleCloseFeedback);
    return function () {
      unsubscribe('question:form:submit', handleShowConfirm);
      unsubscribe('question:open:float:modal', handleRedirectLogin);
      unsubscribe('question:write', handleWriteChars);
      unsubscribe('question:feedback:close', handleCloseFeedback);
    };
  });
  return React.createElement(React.Fragment, null, React.createElement(Dialog, {
    portal: true,
    type: "dialog",
    showClose: true,
    visible: showConfirm,
    position: position,
    onClickOutside: function onClickOutside() {
      setShowConfirm(false);
    },
    bg: "background.white"
  }, React.createElement(React.Fragment, null, React.createElement(Text, {
    fontWeight: "medium",
    mb: 3
  }, "Enviar essa pergunta para a loja?"), React.createElement(Text, {
    my: 4
  }, "\"".concat(chars, "\"")), React.createElement(Text, {
    fontWeight: "bold",
    color: "text.primary",
    mb: 4,
    onClick: handleEdit
  }, "Editar"), React.createElement(Button, {
    "data-testid": "button-confirm",
    full: position === 'bottom',
    centered: true,
    onClick: handleConfirm
  }, React.createElement(Text, {
    fontWeight: "medium",
    color: "text.white"
  }, "Confirmar")))));
};
process.env.NODE_ENV !== "production" ? QuestionConfirm.propTypes = {
  data: shape({}),
  "static": shape({}),
  structure: shape({})
} : void 0;
QuestionConfirm.defaultProps = {
  data: {},
  "static": {
    modal: {
      position: 'bottom'
    }
  },
  structure: {}
};
export default QuestionConfirm;